module.exports = __webpack_public_path__ + "assets/6cdc2bb18aca4d6ab4875cb23b567892.png";